import { Inbox } from '@driftt/api-types'

import { ConversationAPI } from 'api'
import { mapResponse } from 'utils/api'

export const fetchInboxes = (): Promise<Inbox[]> =>
  ConversationAPI.get('/inboxes').then(mapResponse)
